import { render, staticRenderFns } from "./Scroll.vue?vue&type=template&id=2dc0fca9&scoped=true&"
import script from "./Scroll.vue?vue&type=script&lang=js&"
export * from "./Scroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc0fca9",
  null
  
)

export default component.exports